import { IUserProfileEntityClaim } from './logged.in.user';

export interface IEntityRouteAuthConfiguration {
    entity: string;
    permission: PermissionType | PermissionType[];
}

export interface IRouteAuthConfiguration {
    requiresEntityPermissions?: IEntityRouteAuthConfiguration | IEntityRouteAuthConfiguration[];
    requiresAdHocPermissions?: string | string[];
}

export enum PermissionType {
    Read,
    Add,
    Edit,
    Delete
}

export class Permission {
    read: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
    
    constructor(entityClaim: IUserProfileEntityClaim) {
        this.read = entityClaim.read;
        this.add = entityClaim.add;
        this.edit = entityClaim.edit;
        this.delete = entityClaim.delete;
    }

    can(type: PermissionType) {
        switch (type) {
            case PermissionType.Read:
                return this.read;
            case PermissionType.Add:
                return this.add;
            case PermissionType.Edit:
                return this.edit;
            case PermissionType.Delete:
                return this.delete;
        }

        return false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/auth/permission.ts